export function getTrueKeys(obj) {
  const trueKeys = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] === true) {
      trueKeys.push(key);
    }
  }
  return trueKeys;
}
